import { createContext } from 'react';

export type ThemeContextType = {
  theme: string;
  setTheme: (theme: string) => void;
  toggleTheme: () => void;
};

export const ThemeContext = createContext<ThemeContextType>({
  theme: 'light',
  setTheme: () => {
    console.error('ThemeContext is missing a provider.');
  },
  toggleTheme: () => {
    console.error('ThemeContext is missing a provider.');
  },
});
